import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { getUsersList } from "../../store/actions/company/index";
import { useDispatch, useSelector } from "react-redux";
import ClientUsersRow from "./clientUsersRow";

const ClientUsersList = ({ isCustomersListView }) => {
  const dispatch = useDispatch();
  const usersList = useSelector(state => state.usersList);

  useEffect(() => {
    if (isCustomersListView) {
      dispatch(getUsersList(true));
    }
  }, []);

  let users = [];
  if (usersList.itemUsers !== undefined ){
    users = [...usersList.itemUsers];
  }

  return (
    <div className="clientUsersListContainer">
      <h4 className="clientUsersTitle"><FormattedMessage id="dashboard.clientsSection.title" /></h4>
      <ClientUsersRow users={users}/>
    </div>
  );
};

export default ClientUsersList;
